


















































import { Component } from 'vue-property-decorator';
import PercentageBarChart from '../chartjs/PercentageBarChart.vue';
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import ChartNoData from '../ChartNoData.vue';
import ChartLabels from '../ChartLabels.vue';
import { ReportType } from '../../models/reportType';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import {ChartType} from '@/features/reports/models/chartType';
import BaseFlowReport from './baseFlowReport';
import {Series} from '@/features/reports/models';

@Component({
	components: {
		BarChart,
		PercentageBarChart,
		LineChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		FlowIcon,
		HelpIcon
	}
})
export default class EscalationRateCharts extends BaseFlowReport {
	public reportId = ReportType.FLOW_ESCALATIONS;
	public chartType: ChartType = ChartType.PERCENTAGE_BAR;

	public tooltipText = 'A trend showing the proportion of users who completed a flow in which they were handed over to a human';

	public isDataEmpty(): boolean {
		return this.seriesData.data.filter(val => val > 0).length === 0;
	}

	private get seriesData(): Series {
		return this.data.series.filter(series => series.name === 'HandedOver')[0];
	}
}
